﻿import { useEffect, useRef, useState } from 'react';
import { Nav, Navbar as BsNavbar, Container, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/context/AuthContext';
import { FiLogOut, FiGlobe, FiLock } from 'react-icons/fi';
import ChangePasswordModal from '@/components/common/ChangePasswordModal';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();
  const location = useLocation();
  const [showChangePwd, setShowChangePwd] = useState(false);

  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = navRef.current;
    if (el) {
      const h = el.getBoundingClientRect().height;
      document.body.style.setProperty('--navbar-height', h + 'px');
    }
  });

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    sessionStorage.setItem('lang', lng);
  };

  const userName = user ? [user.nome, user.cognome].filter(Boolean).join(' ') || String(user.username || 'Utente') : '';
  const userRole = user?.ruolo_primario || '';
  const userInitials = String(userName).split(' ').map((n: string) => n[0]).join('').toUpperCase().slice(0, 2);

  return (
    <BsNavbar ref={navRef} bg="white" expand="lg" sticky="top" className="border-bottom shadow-sm">
      <Container>
        <BsNavbar.Brand as={Link} to="/visite">
          <img src="/images/logo.png" alt="LMeet" />
        </BsNavbar.Brand>
        <BsNavbar.Toggle />
        <BsNavbar.Collapse>
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/visite/nuova" active={location.pathname === '/visite/nuova'} className="text-dark">
              {t('nav.newVisit')}
            </Nav.Link>
            <Nav.Link as={Link} to="/visite" active={location.pathname === '/visite'} className="text-dark">
              {t('nav.visitList')}
            </Nav.Link>
            <Nav.Link as={Link} to="/prospect" active={location.pathname === '/prospect'} className="text-dark">
              {t('nav.prospectList')}
            </Nav.Link>
            <Nav.Link as={Link} to="/tools" active={location.pathname === '/tools'} className="text-dark">
              {t('nav.tools')}
            </Nav.Link>
          </Nav>
          <Nav className="align-items-center gap-2">
            <NavDropdown
              title={<><FiGlobe className="me-1" />{i18n.language.toUpperCase()}</>}
              align="end"
            >
              <NavDropdown.Item onClick={() => changeLanguage('it')}>🇮🇹 Italiano</NavDropdown.Item>
              <NavDropdown.Item onClick={() => changeLanguage('en')}>🇬🇧 English</NavDropdown.Item>
            </NavDropdown>
            {user && (
              <NavDropdown
                align="end"
                title={
                  <span className="d-inline-flex align-items-center gap-2">
                    <span className="navbar-user-avatar rounded-circle d-inline-flex align-items-center justify-content-center"
                      style={{ width: 32, height: 32, fontSize: 12, backgroundColor: '#b42227', color: '#fff', fontWeight: 600 }}>
                      {userInitials}
                    </span>
                    <span className="d-none d-md-inline text-dark navbar-user-name">
                      {userName}
                    </span>
                  </span>
                }
              >
                <div className="px-3 py-2 border-bottom">
                  <div className="fw-semibold">{userName}</div>
                  {user.email && <div className="text-muted">{(user as any).email}</div>}
                  {userRole && <div className="text-muted small">Ruolo: {userRole}</div>}
                </div>
                <NavDropdown.Item onClick={() => setShowChangePwd(true)}>
                  <FiLock className="me-2" />{t('changePwd.title')}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={logout} className="text-danger">
                  <FiLogOut className="me-2" />{t('nav.logout')}
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
        </BsNavbar.Collapse>
      </Container>

      {user && (
        <ChangePasswordModal
          show={showChangePwd}
          username={user.userid}
          onClose={() => setShowChangePwd(false)}
          onSuccess={() => setShowChangePwd(false)}
        />
      )}
    </BsNavbar>
  );
}




